import { createAsyncThunk, createSlice } from '@reduxjs/toolkit'
import api from '../../api/api'
 
export const follow_shop = createAsyncThunk(
    'follow/follow_shop',
    async (username, { rejectWithValue }) => {
        try {
            const { data } = await api.post(`/shop/${username}/follow`)
            return data
        } catch (err) {
            return rejectWithValue(err.response?.data?.error || 'Xəta baş verdi')
        }
    }
)
 
export const unfollow_shop = createAsyncThunk(
    'follow/unfollow_shop',
    async (username, { rejectWithValue }) => {
        try {
            const { data } = await api.delete(`/shop/${username}/follow`)
            return data
        } catch (err) {
            return rejectWithValue(err.response?.data?.error || 'Xəta baş verdi')
        }
    }
)
 
export const get_following = createAsyncThunk(
    'follow/get_following',
    async (_, { rejectWithValue }) => {
        try {
            const { data } = await api.get('/customer/following')
            return data
        } catch (err) {
            return rejectWithValue(err.response?.data?.error || 'Xəta baş verdi')
        }
    }
)
 
const followSlice = createSlice({
    name: 'follow',
    initialState: {
        isFollowing:    false,
        followerCount:  0,
        following:      [],
        loader:         false,
        errorMessage:   '',
        successMessage: ''
    },
    reducers: {
        messageClear: (state) => {
            state.errorMessage   = ''
            state.successMessage = ''
        },
        setFollowState: (state, { payload }) => {
            state.isFollowing   = payload.isFollowing
            state.followerCount = payload.followerCount
        }
    },
    extraReducers: (builder) => {
        builder
            .addCase(follow_shop.pending,   (state) => { state.loader = true })
            .addCase(follow_shop.fulfilled, (state, { payload }) => {
                state.loader         = false
                state.isFollowing    = payload.isFollowing
                state.followerCount  = payload.followerCount
                state.successMessage = payload.message
            })
            .addCase(follow_shop.rejected,  (state, { payload }) => {
                state.loader       = false
                state.errorMessage = payload
            })
            .addCase(unfollow_shop.pending,   (state) => { state.loader = true })
            .addCase(unfollow_shop.fulfilled, (state, { payload }) => {
                state.loader         = false
                state.isFollowing    = payload.isFollowing
                state.followerCount  = payload.followerCount
                state.successMessage = payload.message
                 state.following = state.following.filter(
        shop => shop.username !== payload.username
    )
            })
            .addCase(unfollow_shop.rejected,  (state, { payload }) => {
                state.loader       = false
                state.errorMessage = payload
            })
            .addCase(get_following.fulfilled, (state, { payload }) => {
                state.following = payload.following
            })
    }
})
 
export const { messageClear, setFollowState } = followSlice.actions
export default followSlice.reducer